     class ModalOpener extends HTMLElement {
            constructor() {
                super();

                if (this.hasAttribute('aria-disabled')) return;
                this.modal = document.getElementById(this.getAttribute('aria-controls'));
                if (!this.modal) return;

                this.addEventListener('click', this.onOpenerClick.bind(this));
                this.addEventListener('keydown', this.onKeyDown.bind(this));
            }

            onOpenerClick(event) {
                event.preventDefault(); // 当不支持 js 的情况下，a 标签可作为回退方案

                if (this.getAttribute('aria-expanded') === 'true') return;
                // this.modal.show(event.target); // 原this.modal.show(this), 将this改成event.target，因为有可能是modal-opener内的子元素触发，比如a标签
                this.modal.show(event.currentTarget); // 原this.modal.show(this), 将this改成event.target，因为有可能是modal-opener内的子元素触发，比如a标签
            }

            /**
             * 键盘事件
             */
            onKeyDown(event) {
                if (['Space', "Enter"].includes(event.code)) {
                    this.modal.show(event.target);
                }
            }

            dispatchEvent(event) {
                return false;
            }
        }
        customElements.define('modal-opener', ModalOpener);

        class ModalDialog extends HTMLElement {
            constructor() {
                super();

                // 打开模态时候允许页面滚动
                this.enableScrollWhenOpen = this.hasAttribute('data-enable-scroll');

                // 禁止其它方式关闭
                if (!this.hasAttribute('data-force')) {
                    this.addEventListener('keyup', (event) => {
                        event.stopPropagation();
                        if (event.code && event.code.toUpperCase() === 'ESCAPE') this.hide();
                    });

                    this.addEventListener('click', (event) => {
                        event.stopPropagation();

                        // this.contains(event.target) 防止嵌套使用
                        if (this.contains(event.target) && event.target.classList.contains('tw-modal-overlay')) this.hide();
                    });
                }

                // 模板编辑模式
                if (window.Shopify.designMode) {
                    document.addEventListener('shopify:section:select', (event) => {
                        if (event.detail.sectionId === this.dataset.section) {
                            this.show();
                        } else {
                            this.hide();
                        }
                    });

                    document.addEventListener('shopify:section:deselect', (event) => {
                        if (event.detail.sectionId === this.dataset.section) {
                            this.hide();
                        }
                    });
                }
            }

            show(opener) {
                this.openedBy = opener;

                this.setAttribute('open', '');
                if (this.openedBy) this.openedBy.setAttribute('aria-expanded', 'true');
                trapFocus(this);

                if (!this.enableScrollWhenOpen) disablePageScroll();
            }

            hide() {
                this.removeAttribute('open');

                if (this.openedBy) {
                    this.openedBy.setAttribute('aria-expanded', 'false');
                    removeTrapFocus(this.openedBy);
                }

                if (!this.enableScrollWhenOpen) enablePageScroll();
            }

            dispatchEvent(event) {
                return false;
            }
        }
        customElements.define('modal-dialog', ModalDialog);